import Base from '../base/base';
import './kl-index.scss';

interface KLIndexOptions {
  debug?: boolean;
  [key: string]: any;
}

export default class KLIndex extends Base {
  constructor(options: KLIndexOptions = {}) {
    super(options.debug || false);
    this.log('KLIndex initialized');
  }
}
